const ChurchHistory = () => {
    const historyData = [
        {
            year: "1984",
            date: "6월11일",
            title: "성실교회 개척",
            content:
                "경기도 의정부시 의정부동 247-17 번지 (2층) 39평을 빌려 (3백만원 보증금에 15만원 월세) 염종석 전도사가 76세된 노모를 모시고 학생 3명으로 교회의 문을 열다.",
            milestone: true,
        },
        {
            year: "1985",
            date: "9월20일",
            title: "교회 확장 이전",
            content: "경기도 의정부시 의정부동 414-10 번지 45평으로 이전하다.",
            milestone: false,
        },
        {
            year: "1985",
            date: "10월 5일",
            title: "강도사 인허",
            content: "염종석 전도사가 강도사 인허를 받아 말씀에 강도권을 갖게 되다.",
            milestone: false,
        },
        {
            year: "1986",
            date: "10월 7일",
            title: "목사 임직",
            content: "염종석 강도사가 목사 임직하여 담임목사로 추대 되다.",
            milestone: true,
        },
        {
            year: "1987",
            date: "10월30일",
            title: "기도실 확보",
            content: "위 주소 지하 25평 기도실 확보하여 더욱 기도에 힘쓰게 되다.",
            milestone: false,
        },
        {
            year: "1988",
            date: "",
            title: "등록번호 부여",
            content: "부동산등기용 등록번호 부여",
            milestone: false,
        },
        {
            year: "1988",
            date: "12월20일",
            title: "성실선교원 운영",
            content: "위 주소 1층 50평을 교육관을 확보하여 성실선교원을 운영하다.",
            milestone: false,
        },
        {
            year: "1989",
            date: "11월30일",
            title: "예배실 확장",
            content: "위 주소 2층 50평 교회 확장하여 예배실을 넓히다.",
            milestone: false,
        },
        {
            year: "1992",
            date: "9월28일",
            title: "건축 부지 매입",
            content: "경기도 의정부시 가능동 396-1,2번지 건축 부지 539평을 매입하다.",
            milestone: true,
        },
        {
            year: "1994",
            date: "6월30일",
            title: "부지 확장",
            content: "경기도 의정부시 가능동 397-1번지 200평 건축 부지로 추가 매입하여 대지면적 739평으로 넓히다.",
            milestone: false,
        },
        {
            year: "1995",
            date: "12월29일",
            title: "예배당 신축 허가",
            content: "예배당 신축 허가 (대지 739평, 건평 600평)를 득하다.",
            milestone: false,
        },
        {
            year: "1996",
            date: "2월24일",
            title: "예배당 건축 착공",
            content: "예배당 건축 공사 착공하여 은혜 중에 완공하다.",
            milestone: false,
        },
        {
            year: "1996",
            date: "9월15일",
            title: "새 성전 건축",
            content: "새 성전 건축하여 첫 예배를 드리다.",
            milestone: true,
        },
        {
            year: "1996",
            date: "10월19일",
            title: "입당 감사예배",
            content: "입당 감사예배로 하나님께 영광을 돌리다.",
            milestone: true,
        },
        {
            year: "1997",
            date: "11월10일",
            title: "주차장 부지 매입",
            content: "군부대 대지(가능동 398-1) 494평 매입하여 주차장과 정원을 꾸미게 되다 (총대지면적 1,223평)",
            milestone: false,
        },
        {
            year: "2001",
            date: "10월10일",
            title: "교육관 확장",
            content: "교육관 확장하여 교육에 중점을 두다.",
            milestone: false,
        },
        {
            year: "2002",
            date: "9월30일",
            title: "성실복지 부지 매입",
            content: "성실복지 부지 (포천시 영북면 야미리 45,46,48, 산70,산75) 52,781평 매입하다.",
            milestone: false,
        },
        {
            year: "2002",
            date: "10월20일",
            title: "헌당예배",
            content: "헌당예배로 하나님께 성전을 봉헌하다.",
            milestone: true,
        },
        {
            year: "2003",
            date: "9월24일",
            title: "교육관 신축 착공",
            content: "교육관을 신축공사를 착공(건평 400평)하여 확장하다.",
            milestone: false,
        },
        {
            year: "2004",
            date: "6월13일",
            title: "설립 20주년",
            content: "교육관 완공 및 설립 20주년 기념 감사예배로 영광을 돌리다.",
            milestone: true,
        },
        {
            year: "2005",
            date: "3월20일",
            title: "친교시설 확장",
            content: "휴게실 및 카페를 친교 시설로 확장하다.",
            milestone: false,
        },
        {
            year: "2009",
            date: "6월14일",
            title: "설립 25주년",
            content: "본당을 리모델링하여 현대식 시설로 꾸미고 설립 25주년 감사예배 및 임직감사예배를 드리다.",
            milestone: true,
        },
        {
            year: "2009",
            date: "11월30일",
            title: "목사관 매입",
            content: "양주시 고읍동 한양수자인@105-702호를 목사관으로 매입하다.",
            milestone: false,
        },
        {
            year: "2010",
            date: "6월25일",
            title: "제2주차장 매입",
            content: "제2주차장 부지(녹양동 318-1, 산76-9) 1,721평을 놀라운 기적으로 매입하다.",
            milestone: false,
        },
        {
            year: "2012",
            date: "11월18일",
            title: "헤세드 체육관 건립",
            content: "제2주차장부지에 헤세드 체육관을 건립하고 준공 감사예배로 하나님께 영광을 돌리다.",
            milestone: true,
        },
        {
            year: "2014",
            date: "6월15일",
            title: "설립 30주년",
            content: "설립 30주년 감사예배 및 임직식을 드리다.",
            milestone: true,
        },
        {
            year: "2017",
            date: "9월24일",
            title: "제2교육관 건축",
            content: "제2교육관 건축하여 다음세대 교육에 힘쓰다.",
            milestone: false,
        },
        {
            year: "2018",
            date: "4월14일",
            title: "제1회 벚꽃축제",
            content: "제1회 벚꽃축제를 실시하다.",
            milestone: false,
        },
        {
            year: "2019",
            date: "5월30일",
            title: "교회 외부 리모델링",
            content: "교회 외부 리모델링하여 새로이 꾸미다.",
            milestone: false,
        },
        {
            year: "2019",
            date: "6월 8일",
            title: "설립 35주년",
            content: "설립 35주년 감사예배 및 임직식을 드리다.",
            milestone: true,
        },
        {
            year: "2021",
            date: "7월5일",
            title: "하꿈아이 영상선교회 발족",
            content: "하꿈아이 영상선교회 발족하여 농어촌 교회와 해외 선교사에게 무료로 영상을 보급하다.",
            milestone: false,
        },
        {
            year: "2022",
            date: "4월17일",
            title: "성실 카페 리모델링",
            content: "성실 카페를 리모델링하여 새로이 꾸미다.",
            milestone: false,
        },
        {
            year: "2022",
            date: "6월14일",
            title: "목양실 리모델링",
            content: "목양실과 당회원실을 리모델링하여 새로이 꾸미다.",
            milestone: false,
        },
        {
            year: "2023",
            date: "4월 8일",
            title: "제2회 벚꽃축제",
            content: "제2회 벚꽃축제를 실시하다.",
            milestone: false,
        },
        {
            year: "2023",
            date: "11월5일",
            title: "교회 미래비전 10년 계획 선포",
            content: "교회 미래비전 10년 계획을 선포하여 다음세대를 세우는 일을 추진하다.",
            milestone: false,
        },
        {
            year: "2024",
            date: "6월28일",
            title: "교회설립 40주년",
            content: "교회설립 40주년을 맞이하여 농어촌 교회 목회자와 해외 선교사를 초청하여 위로회를 갖다.",
            milestone: true,
        },
        {
            year: "2025",
            date: "5월25일",
            title: "원로 목사 및 담임목사 추대",
            content: "염종석목사를 원로목사로 추대하고 김진영목사를 담임목사로 추대하기로 공동의회에서 의결하다.",
            milestone: true,
        },
        {
            year: "2025",
            date: "6월 6일",
            title: "성실선교센터",
            content: "염종석목사가 동두천 안창말로 42번길 8-27를 성실선교센터로 드리다.",
            milestone: false,
        },
        {
            year: "2025",
            date: "8월 2일",
            title: "벧엘(하나님의 집) 선교센터",
            content: "벧엘(하나님의 집) 선교센터 개관예배 드리다.",
            milestone: false,
        },
        {
            year: "2025",
            date: "11월 2일",
            title: "2대 담임목사 임직",
            content: "김진영이 담임목사로 위임되었으며 장로, 권사 은퇴, 임직식을 드리다.",
            milestone: true,
        },
        {
            year: "2025",
            date: "12월 6일",
            title: "염종석 원로목사 은퇴 및 추대 감사예배",
            content: "염종석목사 담임목사 은퇴 및 원로목사 추대 감사예배를 드리다.",
            milestone: true,
        },
        {
            year: "2025",
            date: "12월 14일",
            title: "염종석 원로목사를 선교목사로 추대",
            content: "염종석 원로목사를 선교목사로 추대하다.",
            milestone: true,
        },
    ]

    const milestones = historyData.filter((item) => item.milestone)

    return (
        <div className="church-history">
            <div className="history-container">
                {/* 헤더 섹션 */}
                <div className="history-header">
                    <div className="header-content">
                        <h1>{new Date().getFullYear() - 1984}년간의 하나님의 은혜</h1>
                        <p>1984년 작은 시작부터 지금까지, 하나님의 인도하심으로 성장해온 성실교회의 소중한 발자취입니다.</p>
                        <div className="stats">
                            <div className="stat-item">
                                <span className="number">1984</span>
                                <span className="label">시작년도</span>
                            </div>
                            <div className="stat-item">
                                <span className="number">{new Date().getFullYear() - 1984}</span>
                                <span className="label">년의 역사</span>
                            </div>
                            <div className="stat-item">
                                <span className="number">{milestones.length}</span>
                                <span className="label">주요 이정표</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 주요 이정표 섹션 */}
                <div className="milestones-section">
                    <h2>주요 이정표</h2>
                    <div className="milestones-grid">
                        {milestones.map((item, index) => (
                            <div key={index} className="milestone-card">
                                <div className="milestone-year">{item.year}</div>
                                <div className="milestone-title">{item.title}</div>
                                <div className="milestone-content">{item.content}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 상세 연혁 섹션 */}
                <div className="detailed-history">
                    <h2>상세 연혁</h2>
                    <div className="history-timeline">
                        {historyData.map((item, index) => (
                            <div key={index} className={`timeline-item ${item.milestone ? "milestone" : ""}`}>
                                <div className="timeline-marker">
                                    <div className="year-badge">{item.year}</div>
                                    {item.milestone && <div className="milestone-star">★</div>}
                                </div>
                                <div className="timeline-content">
                                    <div className="content-header">
                                        <h3>{item.title}</h3>
                                        {item.date && <span className="date">{item.date}</span>}
                                    </div>
                                    <p>{item.content}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 감사 메시지 */}
                <div className="gratitude-section">
                    <div className="gratitude-content">
                        <h2>하나님께 감사드립니다</h2>
                        <p>지금까지 시작하시고 지키시며 성장시켜 오신 하나님께 모든 영광을 돌립니다.</p>
                        <div className="signature">※</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChurchHistory
